<div class="full-width has-nav wrapper">
  @if(deviceService.isDesktop()){
  <div class="articles w-5">
    <h1>Tous nos voyages sur une seule carte!</h1>
    @if(selectedMarkerArticles.length > 0){
    <div class="place">
      <div class="place-name">
        <img loading="lazy" class="pin" ngSrc="/map/pin.png" alt="pin" width="27" height="36" />
        <div>
          <h3>{{ selectedMarkerArticles[0].place }}</h3>
          <p>
            {{ selectedMarkerArticles.length }} article{{
              selectedMarkerArticles.length > 1 ? 's' : ''
            }}
          </p>
        </div>
      </div>
      <div class="place-articles">
        <a
          *ngFor="let article of selectedMarkerArticles"
          class="full-width"
          [href]="'/' + article.slug"
        >
          <section class="article">
            <div class="picture w-6">
              <img loading="lazy" [ngSrc]="article.coverPicture!.src" alt="article" fill />
            </div>
            <div class="article-description">
              <div class="destination">
                <p class="upper">
                  {{ article.place }}, <em>{{ article.destination?.country }}</em>
                </p>
                <h3>{{ article.name }}</h3>
              </div>
              <div class="link">
                <img
                  loading="lazy"
                  class="icon"
                  alt="plus"
                  ngSrc="/icons/plus.svg"
                  width="12"
                  height="12"
                />
                <a>
                  <ng-container>Lire l'article</ng-container>
                  <div class="line"></div>
                </a>
              </div>
            </div>
          </section>
        </a>
      </div>
    </div>
    }
  </div>
  }
  <div class="w-x" id="map"></div>
  @if(deviceService.isMobileOrTablet()&& this.selectedMarkerArticles.length > 0) {
  <div class="mobile-wrapper">
    <div
      class="mobile-articles"
      appDrag
      (dragging)="canClick = !$event"
      [contentChange]="contentChange$"
      (currentIndex)="currentArticleIndex = $event"
    >
      <a
        [href]="'/' + article.slug"
        *ngFor="let article of selectedMarkerArticles"
        [class.disabled]="!canClick"
        class="drag-child"
        [class.w-6]="deviceService.isTablet()"
        [class.w-11]="deviceService.isMobile()"
      >
        <section class="article">
          <div class="picture w-4">
            <img
              loading="lazy"
              [ngSrc]="article.coverPicture!.src"
              alt="article"
              [width]="article.coverPicture!.width"
              [height]="article.coverPicture!.height"
            />
          </div>
          <div class="article-description">
            <div class="destination">
              <p class="upper">
                {{ article.place }}, <em>{{ article.destination?.country }}</em>
              </p>
              <h2>{{ article.name }}</h2>
            </div>
          </div>
        </section>
      </a>
    </div>
    <div class="indicators">
      @for(article of selectedMarkerArticles; let index = $index; track $index) {
      <div class="indicator" [class.active]="index === currentArticleIndex"></div>
      }
    </div>
  </div>
  }
</div>
